import { z } from "zod"

const apiVersion = "/v1"

const environmentSchema = z.object({
  VITE_API_URL: z.url({ error: "VITE_API_URL must be an absolute URL" }),
  VITE_APP_NAME: z.string().min(1).default("Merrin"),
  VITE_UPDATE_POLL_INTERVAL: z.coerce.number().int().positive().default(60_000),
})

const parsed = environmentSchema.safeParse(import.meta.env)

if (!parsed.success) {
  const issues = parsed.error.issues
    .map((issue) => `${issue.path.join(".")}: ${issue.message}`)
    .join("\n")

  throw new Error(`Invalid environment configuration.\n${issues}`)
}

export const env = {
  apiUrl: `${parsed.data.VITE_API_URL.replace(/\/+$/, "")}${apiVersion}`,
  appName: parsed.data.VITE_APP_NAME,
  updatePollInterval: parsed.data.VITE_UPDATE_POLL_INTERVAL,
  buildId: __BUILD_ID__,
  isDevelopment: import.meta.env.DEV,
} as const
